import store from '../store'
import router from "../router"

export default {
  namespaced: true,
  state: {
    plan_id: null,
  },
  mutations: {
    setPlan(state, plan_id) {
      state.plan_id = plan_id
    },
  },
  actions: {
    setPlanId({commit}, plan_id) {
      commit('setPlan', plan_id)
    },
  },
  getters: {
    getPlanId(state) {
      return state.plan_id
    },
  }
}
